import useLocales from "hooks/useLocales"
import { ReactComponent as CardIcon } from "assets/icon/card.svg"
import { ReactComponent as StaffIcon } from "assets/icon/staff.svg"
import { ReactComponent as VehicleIcon } from "assets/icon/vehicle.svg"
import { ReactComponent as DriverIcon } from "assets/icon/driver.svg"
import { ReactComponent as DeviceIcon } from "assets/icon/device.svg"
import { ReactComponent as ReportIcon } from "assets/icon/report.svg"
import { ReactComponent as DashboardIcon } from "assets/icon/dashboard.svg"
import { ReactComponent as LocationIcon } from "assets/icon/location.svg"
import { ReactComponent as RouteIcon } from "assets/icon/route.svg"
import { ReactComponent as TripIcon } from "assets/icon/trip.svg"
import { ReactComponent as UserIcon } from "assets/icon/user.svg"
import { ReactComponent as CustomerIcon } from "assets/icon/customer.svg"
import { ReactComponent as UserPermissionIcon } from "assets/icon/user_permission.svg"
import { ReactComponent as GroupPermissionIcon } from "assets/icon/group_permission.svg"
import { ReactComponent as PermissionIcon } from "assets/icon/permission.svg"
import { ReactComponent as FirmwareIcon } from "assets/icon/firmware.svg"
import localeTH from "antd/locale/th_TH"
import localeEN from "antd/locale/en_US"
import Icon, {
  EyeOutlined,
  AuditOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  ContainerOutlined,
  FileTextOutlined,
  FieldTimeOutlined,
  CarOutlined,
  SettingOutlined,
  ShareAltOutlined
} from "@ant-design/icons"
import THLogo from "assets/th.png"
import ENLogo from "assets/usa.png"
import styled from "styled-components"

// navbar
export const NAV_ITEM = [
  {
    key: "dashboard",
    title: "d.dashboard",
    type: "group",
    children: [
      {
        key: "main-dashboard",
        icon: <Icon component={DashboardIcon} />,
        title: "d.dashboard",
        // url: "/main/dashboard",
        url: "/main/tap-card-dashboard",
        display: true
      }
    ]
  },
  {
    key: "master-data",
    title: "m.master-data",
    type: "group",
    children: [
      {
        key: "card",
        icon: <Icon component={CardIcon} />,
        title: "c.card",
        url: "/main/card",
        display: true
      },
      {
        key: "staff",
        icon: <Icon component={StaffIcon} />,
        title: "s.staff",
        url: "/main/staff",
        display: true
      },
      {
        key: "vehicle",
        icon: <Icon component={VehicleIcon} />,
        title: "v.vehicle",
        url: "/main/vehicle",
        display: true
      },
      {
        key: "driver",
        icon: <Icon component={DriverIcon} />,
        title: "d.driver",
        url: "/main/driver",
        display: true
      },
      {
        key: "device",
        icon: <Icon component={DeviceIcon} />,
        title: "d.device",
        url: "/main/device",
        display: true
      },
      {
        key: "bp-monitor-template",
        icon: <Icon component={DeviceIcon} />,
        title: "b.bp-monitor-template",
        url: "/main/bp-monitor-template",
        display: true
      },
      {
        key: "firmware",
        icon: <Icon component={FirmwareIcon} />,
        title: "f.firmware",
        url: "/main/firmware",
        display: true
      },
      {
        key: "customer",
        icon: <Icon component={CustomerIcon} />,
        title: "c.customer",
        url: "/main/customer",
        display: true
      },
      {
        key: "timetable",
        icon: <FieldTimeOutlined />,
        title: "t.timetable",
        url: "/main/timetable",
        display: true
      }
    ]
  },
  {
    key: "manage-travel",
    title: "r.route",
    type: "group",
    children: [
      {
        key: "location",
        icon: <Icon component={LocationIcon} />,
        title: "l.location",
        url: "/main/location",
        display: true
      },
      {
        key: "route",
        icon: <Icon component={RouteIcon} />,
        title: "r.route",
        url: "/main/route",
        display: true
      },
      {
        key: "trip-management",
        icon: <Icon component={TripIcon} />,
        title: "t.trip-management",
        url: "/main/trip-management",
        display: true
      }
    ]
  },
  {
    key: "reports",
    title: "r.reports",
    type: "group",
    children: [
      {
        key: "log-report",
        icon: <Icon component={ReportIcon} />,
        title: "l.log-report",
        url: "/main/reports/log",
        display: true
      },
      {
        key: "alcohol-log",
        icon: <Icon component={ReportIcon} />,
        title: "alcohol-log.title",
        url: "/main/alcohol-log",
        display: true
      },
      {
        key: "blood-pressure-log",
        icon: <Icon component={ReportIcon} />,
        title: "blood-pressure-log.title",
        url: "/main/blood-pressure-log",
        display: true
      }
    ]
  },

  {
    key: "management",
    title: "m.management",
    type: "group",
    children: [
      {
        key: "user",
        icon: <Icon component={UserPermissionIcon} />,
        title: "u.user",
        url: "/main/user",
        display: true
      },
      {
        key: "group",
        icon: <Icon component={GroupPermissionIcon} />,
        title: "g.group",
        url: "/main/group",
        display: true
      },
      {
        key: "permission",
        icon: <Icon component={PermissionIcon} />,
        title: "p.permission",
        url: "/main/permission",
        display: true
      },
      {
        key: "data-visibility",
        icon: <EyeOutlined />,
        title: "d.data-visibility",
        url: "/main/datavisibility",
        display: true
      },
      {
        key: "stop-parked-config",
        icon: <SettingOutlined />,
        title: "stop-parked-config.title",
        url: "/main/stop-parked-config",
        display: true
      },
      {
        key: "customer-share-link",
        icon: <ShareAltOutlined />,
        title: "customer-share-link.title",
        url: "/main/customer-share-link",
        display: true
      },
      {
        key: "vehicle-type-rule",
        icon: <SettingOutlined />,
        title: "vehicle-type-rule.title",
        url: "/main/vehicle-type-rule",
        display: true
      },
      {
        key: "auto-merge-rule",
        icon: <SettingOutlined />,
        title: "auto-merge-rule.title",
        url: "/main/auto-merge-rule",
        display: true
      },
      {
        key: "schedule-settings",
        permission_key: "schedule-settings",
        icon: <SettingOutlined />,
        title: "s.schedule-settings",
        url: "/main/schedule-settings",
        display: true
      }
    ]
  },

  {
    key: "booking-management-centre",
    title: "b.booking-management",
    type: "group",
    children: [
      {
        key: "transport-booking-request",
        icon: <FileTextOutlined />,
        title: "t.transport-booking-request",
        url: "/main/transport-booking-request",
        display: true
      },
      {
        key: "transport-booking-management",
        icon: <AuditOutlined />,
        title: "t.transport-booking-management",
        url: "/main/transport-booking-management",
        display: true
      },
      {
        key: "transport-booking-form",
        icon: <FileTextOutlined />,
        title: "t.transport-booking-form",
        url: "/main/transport-booking-form",
        display: false
      },
      {
        key: "vehicle-type-planning",
        icon: <CarOutlined />,
        title: "v.vehicle-type-planning",
        url: "/main/vehicle-type-planning",
        display: true
      },
      {
        key: "vehicle-assignment",
        icon: <CarOutlined />,
        title: "v.vehicle-assignment",
        url: "/main/vehicle-assignment",
        display: true
      },
      {
        key: "booking-setting",
        permission_key: "booking-setting",
        icon: <SettingOutlined />,
        title: "booking-setting.title",
        url: "/main/booking-setting",
        display: true
      }
    ]
  }
]

// responsive
export const BREAKPOINTS = {
  xs: 360,
  sm: 568,
  md: 768,
  lg: 992,
  xl: 1280,
  xxl: 1920
}

const getMedia = (breakpoint) => `(min-width: ${breakpoint}px)`

export const media = {
  xs: getMedia(BREAKPOINTS.xs),
  sm: getMedia(BREAKPOINTS.sm),
  md: getMedia(BREAKPOINTS.md),
  lg: getMedia(BREAKPOINTS.lg),
  xl: getMedia(BREAKPOINTS.xl),
  xxl: getMedia(BREAKPOINTS.xxl)
}

export const HOST_API = process.env.REACT_APP_LARAVEL_ENDPOINT || ""

const ImgContainer = styled.div({
  position: "flex-start"
})

export const LANGS = [
  {
    label: "TH",
    value: "th",
    systemValue: localeTH,
    icon: (
      <ImgContainer>
        <img src={THLogo} alt="th logo" className="language-icon" />
      </ImgContainer>
    )
  },
  {
    label: "EN",
    value: "en",
    systemValue: localeEN,
    icon: (
      <ImgContainer>
        <img src={ENLogo} alt="en logo" className="language-icon" />
      </ImgContainer>
    )
  }
]
